// @flow
import { type ComponentType } from 'react'
import styled from 'styled-components'
import { screenMaxS, screenMaxM, screenMaxL } from 'utils/styled'

export const Root: ComponentType<{|
  children: React$Node,
  className?: string,
  fluid: boolean,
  textAlign?: 'left' | 'center' | 'right' | 'justified',
|}> = styled.div`
  display: block;
  width: 100%;
  max-width: ${({ fluid }) => (fluid ? 'none' : '1280px')};
  text-align: ${({ textAlign }) => textAlign || 'inherit'};
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 40px;
  ${screenMaxL()`
    padding: 0 40px;
  `}
  ${screenMaxM()`
    max-width: initial;
    padding: 0 34px;
  `}
  ${screenMaxS()`
    padding: 0 20px;
  `}
`
